class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.modalBg = document.getElementById('cart-notification__modal-bg');
    this.notification = document.getElementById('cart-notification');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.quantityAddedHeading = document.getElementById('quantity-added');
    this.itemAdded = document.getElementById('item-added');
    this.insertOnly = document.getElementById('insert-only');
    this.outletOnly = document.getElementById('outlet-only');
    this.switchOnly = document.getElementById('switch-only');
    this.optionalProductCard = document.getElementById('cart-notification-optional-product');
  }

  open(quantityAdded) {
    // Hide support bubble
    document.getElementById('launcher').classList.add('hidden');

    // Update header quantity count
    if (quantityAdded == 1) {
      this.quantityAddedHeading.innerText = quantityAdded + ' item added';
    } else {
      this.quantityAddedHeading.innerText = quantityAdded + ' items added';
    }

    // Display notification panel & black background
    this.notification.classList.add('animate', 'active');
    this.modalBg.classList.add('show');
    
    // Prevent body scrolling
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100%';

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    // Show support bubble
    document.getElementById('launcher').classList.remove('hidden');

    // Hide notification panel & black background
    this.notification.classList.remove('active');
    this.modalBg.classList.remove('show');

    // Enable body scolling
    document.body.style.overflow = 'auto';
    document.body.style.height = 'auto';

    // Reset all 'item added' messages
    let messageList = document.getElementsByClassName('item-added');
    for (let message of messageList) {
      if (message.classList.contains('show')) {
        message.classList.remove('show');
      }
    }

    // Reset all yellow warnings
    let warningList = document.getElementsByClassName('yellow-warning');
    for (let warning of warningList) {
      if (warning.classList.contains('hidden')) {
        warning.classList.remove('hidden');
      }
    }

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }
  
  renderContents(parsedState, quantityAdded, optionalProductId) {
    // Get main product id
    this.productId = parsedState.id;
    // Get main product type
    this.productType = parsedState.product_type;
    
    // If main product is selected
    if (optionalProductId == undefined) {
      
      // Hide optional product card
      this.optionalProductCard?.classList.add('hidden');

      this.defaultSections().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      // Based on product type - show 'cart-add-device' element
      if (this.productType == 'Insert') {
        this.insertOnly.classList.remove('hidden');
      }
    }

    this.open(quantityAdded);
  }

  // Sections to render if only main product is selected
  defaultSections() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  // Sections to render if main & optional products are selected
  optionalSections() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-optional-product',
        selector: `#cart-notification-optional-product-${this.optionalProductId}`,
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target == this.modalBg) {      
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
